import { MembersPage } from '@src/components/sco/Members/MembersLayout'
import { MembersMainPanel } from '@src/components/sco/Members/MembersLayout/MembersMainPanel'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import router from 'next/router'
import { useEffect } from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default MembersPage(function Chat() {
  const activeContent = useActiveContentContext()

  useEffect(() => {
    router.push('/inbox')
  }, [])

  useUniversalEffect(() => {
    activeContent.setSiteSection('chat.landing')
    activeContent.setBreadcrumbs([
      {
        title: 'Members',
        href: '/members',
      },
      {
        title: 'Slack Chat',
        href: '/chat',
      },
    ])
  })

  return <MembersMainPanel></MembersMainPanel>
})
